export const CONFIRM_ACTION_REQUESTED = 'CONFIRM_ACTION_REQUESTED';
export const PROCEED_ACTION = 'PROCEED_ACTION';
export const CANCEL_ACTION = 'CANCEL_ACTION';



// WEBPACK FOOTER //
// ./src/services/confirmAction/actionTypes.js